module.exports = __webpack_public_path__ + "img/FR11689.9703bdcf.png";